interface Props {
  onCreateRegion: () => void;
  onCreateOrganization?: () => void;
}

export function OrgUnitEmptyState({ onCreateRegion, onCreateOrganization }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-8 text-center">
      <div className="text-ems-text-secondary text-sm mb-1">No org units yet</div>
      <div className="text-ems-text-muted text-xs mb-4">
        {onCreateOrganization
          ? 'Create an organization or region to start organising your sites.'
          : 'Create a region to start organising your sites.'}
      </div>
      <div className="flex gap-2">
        {onCreateOrganization && (
          <button
            type="button"
            onClick={onCreateOrganization}
            className="px-3 py-1.5 rounded bg-ems-forest text-ems-green border border-ems-green/20 text-xs hover:bg-ems-forest/80"
          >
            Create your first organization
          </button>
        )}
        <button
          type="button"
          onClick={onCreateRegion}
          className="px-3 py-1.5 rounded bg-ems-forest text-ems-green border border-ems-green/20 text-xs hover:bg-ems-forest/80"
        >
          Create your first region
        </button>
      </div>
    </div>
  );
}
